import styled from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ButtonWrapper = styled.div<{
    btnColor: string
}>`
    display: flex;
    padding: 0.5em 0.75em 0.75em;
    margin: 0.5em 0.75em 0.75em;
    background-color: white;
    color: ${({ btnColor }) => btnColor};
    border-radius: 5px;
    flex-direction: column;
    align-items: center;
    width: 120px;
    height: 120px;
    max-width: 120px;
    max-height: 120px;
    aspect-ratio: 1/1;
    flex-grow: 1;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    &:hover {
        background-color: ${({ btnColor }) => btnColor};
        color: white;
        cursor: pointer;
    }
`

export const IconWrapper = styled.div`
    position: relative;
    height: 80%;
    aspect-ratio: 1/1;
`

export const SettingIcon = styled(FontAwesomeIcon)`
    width: 80% !important;
    height: 80%;
    margin-left: 10%;
`

export const CogIcon = styled(FontAwesomeIcon)`
    opacity: 60%;
    width: 30% !important;
    height: 30%;
    position: absolute;
    bottom: 0;
    right: 0;
`

export const IconText = styled.p`
    line-height: 1.2;
    margin: 0;
    text-align: center;
`
